import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../allcss/blog10.css';
import blogImage from '../Asets/Blog.jpg';      // hero background
import diwaliImg from '../Asets/blog1010.png';  // detail image
import Header from '../components/header';
import Footer from '../components/footer';

const Blog10 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: 'pointer', color: '#fff' }}
                onClick={() => navigate('/')}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            Lighting Up Diwali: Exploring Traditions and Art with Preschoolers | Red School House Vadodara
          </h2>
          <br />
          <div className="published-badge">Published on: 01 October 2025</div>
          <br />

          <img
            src={diwaliImg}
            alt="Lighting Up Diwali with Preschoolers"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              <strong>Diwali is more than just a festival of lights—it’s a celebration of love,
              family, joy, and togetherness.</strong> For children, especially preschoolers, Diwali
              is an exciting time filled with sparkling diyas, colorful rangoli, delicious
              sweets, and fun traditions.
            </p>
            <p>
              At <strong>Red School House Vadodara</strong>, we believe festivals are not only
              about celebration but also about learning and bonding. <strong>Diwali gives children the
              chance to explore art, culture, and values</strong> in playful ways that spark creativity
              and curiosity.
            </p>

            <h3>Fun and Meaningful Ways to Celebrate Diwali with Preschoolers</h3>

            <h3>🪔 1. Storytelling – Learning the Legends</h3>
            <p>
              Children love stories, and Diwali is full of beautiful ones—like the return of
              Lord Rama to Ayodhya or the celebration of Goddess Lakshmi. <strong>Sharing these stories
              in simple language helps preschoolers understand the values of goodness, kindness,
              and light winning over darkness.</strong>
            </p>

            <h3>🎨 2. Rangoli and Art Activities</h3>
            <p>
              Little ones can explore their artistic side by making simple rangoli with colored
              paper, flower petals, or crayons. <strong>This activity improves fine motor skills and
              builds cultural connection.</strong>
            </p>

            <h3>🕯️ 3. Diyas and Crafts</h3>
            <p>
              Decorating diyas with paint, glitter, or stickers is always a preschool favorite!
              <strong> Hands-on making builds confidence and creativity</strong> as children create something to
              light up their homes.
            </p>

            <h3>🍬 4. Sharing Sweets and Snacks</h3>
            <p>
              Diwali is incomplete without sweets. <strong>Involving children in safe, simple kitchen
              activities—like rolling laddoos or arranging snacks—teaches the joy of sharing.</strong>
            </p>

            <h3>💖 5. Teaching Values of Togetherness</h3>
            <p>
              Diwali is the perfect time to teach values like <strong>gratitude, family bonding,
              sharing, and kindness</strong>. These early lessons shape character and bring the true
              spirit of the festival into children’s hearts.
            </p>

            <h3>How Red School House Vadodara Celebrates</h3>
            <ul>
              <li><strong>Storytelling sessions</strong> about Diwali legends</li>
              <li><strong>Hands-on art and craft activities</strong> (diyas, lanterns, rangoli)</li>
              <li>Singing festive songs and rhymes</li>
              <li>Teaching children about <strong>safety during fireworks</strong></li>
              <li><strong>Sharing treats with friends</strong> to spread happiness</li>
            </ul>
            <p>
              <strong>We combine culture with creativity</strong> so that every child experiences Diwali not only
              as a festival but also as a lesson in love, light, and learning.
            </p>

            <h3>About Red School House Vadodara</h3>
            <p>
              At <strong>Red School House Vadodara</strong>, we create a nurturing environment
              where every day is filled with curiosity and joy. Known as the <strong>Best Nursery School
              in Vadodara</strong>, our focus on learning through play, stories, and art helps children
              explore traditions while developing life skills.
            </p>

            <p>
              <strong>Address:</strong> A-25, Castle White, Opposite Main, Harni Water Tank, Harni Sama Link Road, Vadodara – 390008
              <br />
              <strong>Mobile:</strong> +91 7778851070
              <br />
              <strong>Email:</strong> redschoolhousebaroda2025@gmail.com
              <br />
              <strong>Website:</strong>{' '}
              <a href="https://redhouseschoolvadodara.in/" target="_blank" rel="noreferrer">
                redhouseschoolvadodara.in
              </a>
              <br />
              <strong>Instagram:</strong>{' '}
              <a href="https://www.instagram.com/redschoolhousebaroda" target="_blank" rel="noreferrer">
                @redschoolhousebaroda
              </a>
              <br />
              <strong>Google Business Profile:</strong>{' '}
              <a href="https://www.google.com/search?q=Red+School+House+Vadodara" target="_blank" rel="noreferrer">
                Click Here
              </a>
            </p>

            <h3>Final Thoughts</h3>
            <p>
              <strong>Diwali is not only about fireworks and lights—it’s about values, culture, and
              togetherness.</strong> When celebrated with creativity and care, it becomes a wonderful
              opportunity for preschoolers to learn, express themselves, and build happy memories.
              At <strong>Red School House Vadodara</strong>, we light up little hearts with the joy of learning—just
              like diyas brighten our homes during Diwali.
            </p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate('/blog')}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog10;
